const arr = [
  {//优惠券列表
    path:'list',
    name:'list',
    component: resolve => {
      require(['../views/Coupon/list.vue'], resolve)
    },
    meta:{
      title:'我的优惠券'
    }
  },
  {//分享券页面
    path:'share',
    name:'share',
    component: resolve => {
      require(['../views/Coupon/share.vue'], resolve)
    },
    meta:{
      title:'分享券'
    }
  },
  {//延时券列表
    path:'delay',
    name:'delay',
    component: resolve => {
      require(['../views/Coupon/delay.vue'], resolve)
    },
    meta:{
      title:'延期券'
    }
  },
  {//分享券激活服务页面
    path:'getService',
    name:'getService',
    component: resolve => {
      require(['../views/Coupon/getService.vue'], resolve)
    },
    meta:{
      title:'分享券邀请'
    }
  },
]

export default arr



// WEBPACK FOOTER //
// ./src/router/coupon.js